// extracted by mini-css-extract-plugin
export default {"errorMessage":"ErrorChip_errorMessage__9WkDZ","errorIcon":"ErrorChip_errorIcon__Brs8z"};